import styled from '@emotion/styled'
import theme from '@utils/theme'

// HomePage Styles

export const HomePageWrapper = styled.div``

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 640) {
    font-size: 20px;
  }
`

// Genres Books Styles

export const GenreListing = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  align-items: center;
  gap: 40px;
  padding: 10px 8px;

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  &::-webkit-scrollbar-thumb {
    background: transparent; /* Make thumb transparent by default */
    border-radius: 10px;
  }

  /* Show scrollbar thumb only on hover */
  &:hover {
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2); /* Show the thumb on hover */
    }
  }
`
export const GenreImageWrapper = styled.div<{ colorIndex?: number }>`
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 100%;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  /* Alternate background colors */
  background: ${({ colorIndex }) =>
    colorIndex % 2 === 0 ? '#e0f0fe' : '#fff2d5'};

  &.active {
    /* Maintain the alternating color even when active */
    background: ${({ colorIndex }) =>
      colorIndex % 2 === 0 ? '#b8e1ff' : '#ffddb0'};

    /* Alternate shadow effect */
    box-shadow: 0 0 15px
      ${({ colorIndex }) =>
        colorIndex % 2 === 0
          ? 'rgba(0, 102, 204, 0.3)' /* Light blue shadow */
          : 'rgba(243, 166, 22, 0.3)'}; /* Orange-tinted shadow */
  }

  @media (max-width: 640px) {
    width: 70px;
    height: 70px;
  }
`

// Books Styles

export const BookListing = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  gap: 40px;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  @media (max-width: 768px) {
    gap: 30px;
    justify-content: flex-start;
  }
`

export const StyleAllBooks = styled.div`
  // display: flex;
  // gap: 40px;
  // flex-wrap: wrap;

  // @media (max-width: 768px) {
  //   gap: 20px;
  // }

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
`

export const IndividualBook = styled.li`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  max-width: 200px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-5px);
  }

  &:hover img {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    min-width: 160px;
    max-width: 200px;
    gap: 12px;
  }

  @media (max-width: 640px) {
    min-width: 140px;
    max-width: 200px;
    gap: 10px;
  }
`

export const CoverImage = styled.div`
  width: 100%;
  aspect-ratio: 2/3;
  border-radius: 8px;
  height: auto;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`

export const BookImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
`

export const BookDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 4px;
`

export const BookName = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
  }
`

export const CategoryRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
`

export const AuthorName = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: #666; // Use direct color values
  margin: 0;

  @media (min-width: 768px) {
    font-size: 14px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`

export const BookCategory = styled.span`
  font-size: 11px;
  font-weight: 400;
  padding: 2px 6px;
  width: fit-content;
  background-color: #e0f0e0;
  border-radius: 4px;

  @media (min-width: 768px) {
    font-size: 12px;
    padding: 3px 7px;
  }

  @media (min-width: 1024px) {
    font-size: 14px;
    padding: 4px 8px;
  }
`

export const NoBooks = styled.span`
  font-size: 16px;
  color: #999;
  padding: 40px 0;
  margin: 0 auto;
  width: 100%;
  align-items: center;
  justify-content: center;
`
export const ShowAllButton = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.primary};
  cursor: pointer;
  background: none;
  white-space: nowrap;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

// Add these to your style.js file

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  flex-direction: column;
  gap: 10px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

interface PageButtonProps {
  active?: boolean
}

export const PageButton = styled.button<PageButtonProps>`
  min-width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid ${(props) => (props.active ? '#4285f4' : '#e0e0e0')};
  background-color: ${(props) => (props.active ? '#4285f4' : 'white')};
  color: ${(props) => (props.active ? 'white' : '#333')};
  font-size: 14px;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.active ? '#4285f4' : '#f5f5f5')};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const PageInfo = styled.div`
  font-size: 14px;
  color: #666;
  margin-right: 20px;
`

// src/components/Banner/style.ts
import { keyframes } from '@emotion/react'

const slideInFromRight = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`

const slideOutToLeft = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
`

export const BannerContainer = styled.div`
  position: relative;
  width: 100%;
  height: clamp(180px, 30vw, 500px);
  overflow: hidden;
  border-radius: 10px;
  background-color: #f0f0f0; /* Light background for empty state */
  margin-bottom: 20px; /* Space between banner and content below */
`

export const BannerImage = styled.img<{
  isActive: boolean
  isLeaving: boolean
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  animation: ${(props) =>
      props.isLeaving
        ? slideOutToLeft
        : props.isActive
          ? slideInFromRight
          : 'none'}
    0.5s ease-in-out;
  z-index: ${(props) => (props.isActive ? 2 : 1)};
`

export const BannerDots = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 3;
`

export const BannerDot = styled.span<{ active: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? '#007bff' : 'rgba(255,255,255,0.5)'};
  cursor: pointer;
  transition: background-color 0.3s ease;
`
